import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Status } from '../Status';

const RESOLUTION_STATUS = {
  pending_review: { label: 'Generated', color: 'pending' },
};

const NOT_ISSUED = { label: 'Not issued', color: 'neutral' };

const ResolutionStatus = ({ resolution }) => {
  const theme = useTheme();

  const { label, color } = !resolution
    ? NOT_ISSUED
    : resolution.mailDocId
      ? { label: 'Sent', color: 'success' }
      : (RESOLUTION_STATUS[resolution.status] ?? NOT_ISSUED);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} data-cy="resolutionStatus">
      <Status sx={{ marginRight: theme.spacing(1) }} color={color} size="sm" />
      {label}
    </Box>
  );
};

ResolutionStatus.propTypes = {
  resolution: PropTypes.object,
};

export default ResolutionStatus;
